<template>
  <div class="open-app">
    
    <p >앱을 여는 중입니다... 잠시만 기다려주세요.</p>
    <a ref="iosLink" :href="target" style="display: none;">앱 열기</a>
  </div>
</template>

<script>
export default {
  name: 'OpenApp',
  data() {
    return {
      fallbackUrl: '',
      showSafariGuide: false,
    };
  },
  created() {
  const encodedPath = this.$route.query.target;
  const userAgent = navigator.userAgent || navigator.vendor;
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  
    if (!encodedPath && !isIOS) {
      window.location.href=`https://play.google.com/store/apps/details?id=com.zikooapp`
      return;
    }else if((!encodedPath && isIOS)){
      window.location.href =`${process.env.VUE_APP_MAIN_URL}`
      return;
    }

    const decodedPath = decodeURIComponent(encodedPath); // ex: /product/123414
    let schemeUrl = `${process.env.VUE_APP_MAIN_URL}${decodedPath}`;       // 최종 딥링크


    const fallbackUrl =  `${process.env.VUE_APP_MAIN_URL}${decodedPath}`;
    if(!isIOS){
      schemeUrl = `intent://zikoo.co.kr/${decodedPath}#Intent;scheme=https;package=com.zikooapp;S.browser_fallback_url=${fallbackUrl};end`;
    
    }else{
      schemeUrl = `zikooapp://zikoo.co.kr/${decodedPath}`
      const timeout = setTimeout(() => {
        window.location.href =   `${process.env.VUE_APP_MAIN_URL}${decodedPath}`;
      }, 2500);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout);
        }
      });
      
    }
  
    window.location.href = schemeUrl;

  },

};
</script>

<style scoped>
.open-app {
  padding: 40px;
  text-align: center;
  font-size: 16px;
}
</style>
